import { formatGender, formatNameLastFirst } from '@strata/helper-functions';
import { Dialog } from '@strata/react-dialog';
import { InlineMessage } from '@strata/react-inline-message';
import { AddressDetailLabelValue, DetailLabelValuePair } from '@strata/react-label-value-pairs';
import PropTypes from 'prop-types';

const getInlineMessage = (patientDetails) => {
    switch (patientDetails?.is_eligible) {
        case true:
            return 'Patient is eligible.';
        case false:
            return 'Patient is ineligible.';
        default:
            return 'Unable to verify benefits and eligibility.';
    }
};

export const ConfirmPatientDialog = ({
    isOpen = false,
    patientDetails = undefined,
    onConfirm = undefined,
    onReturnToForm = undefined,
}) => (
    <Dialog
        dialogTitle={patientDetails !== null ? 'Confirm Patient' : 'Patient Not Found'}
        primaryButtonLabel="Confirm Patient"
        secondaryButtonLabel="Return to Form"
        onPrimaryButtonClick={onConfirm}
        onSecondaryButtonClick={onReturnToForm}
        isPrimaryButtonDisabled={!patientDetails?.is_eligible}
        isOpen={isOpen}
        dialogContent={
            <>
                <div className="padding__bottom--medium">
                    <InlineMessage
                        intent={
                            patientDetails?.is_eligible
                                ? InlineMessage.Intent.SUCCESS
                                : InlineMessage.Intent.ERROR
                        }
                        label={getInlineMessage(patientDetails)}
                    />
                </div>
                {patientDetails !== null ? (
                    <>
                        <div
                            className="padding__bottom--medium"
                            style={{ display: 'flex', flexDirection: 'row' }}
                        >
                            <DetailLabelValuePair
                                label="Patient Name"
                                value={formatNameLastFirst(
                                    patientDetails?.patient_last_name,
                                    patientDetails?.patient_first_name,
                                )}
                                className="padding__right--large"
                            />
                            <DetailLabelValuePair
                                label="Age"
                                value={patientDetails?.member_age}
                                className="padding__right--large"
                            />
                            <DetailLabelValuePair
                                label="Gender"
                                value={formatGender(patientDetails?.gender)}
                            />
                        </div>
                        <AddressDetailLabelValue
                            label="Address"
                            className="padding__bottom--small"
                            address1={patientDetails?.patient_address_line_1}
                            address2={patientDetails?.patient_address_line_2}
                            city={patientDetails?.member_city}
                            state={patientDetails?.member_state}
                            zip={patientDetails?.member_zip}
                        />
                    </>
                ) : (
                    <div>
                        If you have entered incorrect information, please return to the form and
                        correct it.
                    </div>
                )}
            </>
        }
    />
);

ConfirmPatientDialog.propTypes = {
    isOpen: PropTypes.bool,
    patientDetails: PropTypes.shape({
        patient_first_name: PropTypes.string,
        patient_last_name: PropTypes.string,
        member_age: PropTypes.number,
        gender: PropTypes.string,
        is_eligible: PropTypes.bool,
        patient_address_line_1: PropTypes.string,
        patient_address_line_2: PropTypes.string,
        member_city: PropTypes.string,
        member_state: PropTypes.string,
        member_zip: PropTypes.string,
    }),
    onConfirm: PropTypes.func,
    onReturnToForm: PropTypes.func,
};
